import React, { FunctionComponent } from "react"
import { springDelay } from "./utils/animationUtils"

export const DOT_GRAPH_COLS = 28
export const DOT_GRAPH_ROWS = 10

const DOT_SIZE = 4
const DOT_GAP = 6

const ON_COLOR = "#00F9A1"
const ON_DROP_SHADOW = "drop-shadow(0 0 3px rgba(0, 249, 161, 0.50))"
const OFF_COLOR = "rgba(255, 255, 255, 0.05)" // white-100

const COL_STAGGER = 7 // ms per column, left-to-right
const ROW_DURATION = 150 // ms for the full row stagger (bottom to top)

export interface DotGraphProps {
    data: number[]
    maxValue: number
}

export const DotGraph: FunctionComponent<DotGraphProps> = ({ data, maxValue }) => {
    return (
        <div className="flex" style={{ gap: DOT_GAP }}>
            {Array.from({ length: DOT_GRAPH_COLS }, (_, col) => {
                const value = data[col] ?? 0
                const filledRows =
                    maxValue > 0 ? Math.round((value / maxValue) * DOT_GRAPH_ROWS) : 0
                return (
                    <div key={col} className="flex flex-col-reverse" style={{ gap: DOT_GAP }}>
                        {Array.from({ length: DOT_GRAPH_ROWS }, (_, row) => {
                            const isActive = row < filledRows
                            const delay =
                                springDelay(row / (DOT_GRAPH_ROWS - 1), ROW_DURATION) +
                                col * COL_STAGGER
                            return (
                                <div
                                    key={row}
                                    className="relative rounded-full"
                                    style={{
                                        width: DOT_SIZE,
                                        height: DOT_SIZE,
                                        backgroundColor: OFF_COLOR,
                                    }}
                                >
                                    {isActive && (
                                        <div
                                            className="absolute inset-0 rounded-full motion-safe:animate-pip-fill"
                                            style={{
                                                backgroundColor: ON_COLOR,
                                                filter: ON_DROP_SHADOW,
                                                animationDelay: `${delay}ms`,
                                            }}
                                        />
                                    )}
                                </div>
                            )
                        })}
                    </div>
                )
            })}
        </div>
    )
}

export const EmptyDotGraph: FunctionComponent = () => {
    return (
        <div className="flex" style={{ gap: DOT_GAP }}>
            {Array.from({ length: DOT_GRAPH_COLS }, (_, col) => (
                <div key={col} className="flex flex-col-reverse" style={{ gap: DOT_GAP }}>
                    {Array.from({ length: DOT_GRAPH_ROWS }, (_, row) => (
                        <div
                            key={row}
                            className="rounded-full"
                            style={{
                                width: DOT_SIZE,
                                height: DOT_SIZE,
                                backgroundColor: OFF_COLOR,
                            }}
                        />
                    ))}
                </div>
            ))}
        </div>
    )
}
